/**
  * @example
  *   SectionRenderingApi.fetchSection({ id: "fyre-header" })
  *   SectionRenderingApi.fetchSections({ ids: ['fyre-header', 'fyre-footer'] })
  */
class SectionRenderingApi {
  static async fetchSection({ id, page } = {}) {
    try {
      if (!id) throw "Missing section ID";

      const params = new URLSearchParams(window.location.search)
      params.append("section_id", id);
      if (page) params.append("page", page)

      const res = await fetch(`${window.location.pathname}?${params.toString()}`)
      const text = await res.text()
      const html = new DOMParser().parseFromString(text, 'text/html')
      console.log(html)
      console.log(
        html.querySelector(`div#shopify-section-${id}`)
      )

      return html.querySelector(`#shopify-section-${id}`); 
    } catch (err) {
      console.log(err)
    }
  }

  static async fetchSections({ ids = [], page } = {}) {
    try {
      if (!ids.length) throw "Missing section IDs";

      const params = new URLSearchParams(window.location.search)
      params.append("sections", ids.join(','));
      if (page) params.append("page", page)

      const res = await fetch(`${window.location.pathname}?${params.toString()}`)
      const json = await res.json()
      const parser = new DOMParser()
      const result = {}
      ids.forEach(id => result[id] = parser.parseFromString(json[id], 'text/html').querySelector(`div#shopify-section-${id}`))
      console.log(json)
      console.log(result)

      return result
    } catch (err) {
      console.log(err)
    }
  }
}
